import {createContext, useReducer} from "react";

export const TableContext = createContext();

export const initData = {
    //DatePicker
    dateRange: Array(new Date(new Date().setMonth(new Date().getMonth() -6)), new Date()),

    //검색 조건
    // mainCode: "",
    // subCode: "",
    mainCode: {}, // 빈 문자열("")에서 빈 객체({})로 수정
    subCode: {},  // 빈 문자열("")에서 빈 객체({})로 수정

    //선택된 검색 조건
    selectedMain: "",
    selectedSub: "",
}

export const TableStateType = {
    DATE_RANGE: 'UPDATE_DATE_RANGE',
    MAIN_CODE: 'UPDATE_MAIN_CODE',
    SUB_CODE: 'UPDATE_SUB_CODE',
    SELECTED_MAIN: 'UPDATE_SELECTED_MAIN_CODE',
    SELECTED_SUB: 'UPDATE_SELECTED_SUB_CODE'
}

const reducer = (state, action) => {
    switch (action.type) {
        case TableStateType.DATE_RANGE: {
            return { ...state, dateRange: action.data }
        }
        // case TableStateType.MAIN_CODE: {
        //     return { ...state, mainCode: action.data }
        // }
        // case TableStateType.SUB_CODE: {
        //     return { ...state, subCode: action.data }
        // }
        case TableStateType.MAIN_CODE: {
            // ✅ "" (빈 문자열)이 들어올 경우를 대비하여 {}로 변환
            const newMainCode = typeof action.data === 'object' && action.data !== null ? action.data : {};
            return { ...state, mainCode: newMainCode }
        }
        case TableStateType.SUB_CODE: {
            // ✅ "" (빈 문자열)이 들어올 경우를 대비하여 {}로 변환
            const newSubCode = typeof action.data === 'object' && action.data !== null ? action.data : {};
            return { ...state, subCode: newSubCode }
        }
        case TableStateType.SELECTED_MAIN: {
            return { ...state, selectedMain: action.data }
        }
        case TableStateType.SELECTED_SUB: {
            return { ...state, selectedSub: action.data }
        }
        default:
            return state;
    }
}

const TableProvider = ({children}) => {
    const [state, dispatch] = useReducer(reducer, initData);

    const value = {
        state: state, // ✅ state 객체를 직접 전달
        actions: { contextDispatch: dispatch }
    }

    return (
        <TableContext.Provider value={value}>
            {children}
        </TableContext.Provider>
    )
}

export default TableProvider;